import * as _ from 'lodash'
import initialState from './initialState'

function Profile(state = initialState, action) {

    if (_.isUndefined(action)) {
        return state
    }

    const { type, payload } = action

    switch (type) {
      case 'UPDATE_PROFILE':
        return {'profile' : payload}
      default:
        return state
    }

}

export default Profile
